import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatDialogModule } from '@angular/material/dialog';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { BreadcrumbsComponent } from '@app/shared/components/breadcrumbs/breadcrumbs.component';
import { SearchFieldComponent } from '@app/shared/components/search-field/search-field.component';
import { StatusCircleComponent } from '@app/shared/components/status-circle/status-circle.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { CommunicatorService } from '@shared/services/communicator.service';
import { NotificationService } from '@shared/services/notification.service';
import { GeoIpService } from '@shared/services/geo-ip.service';
import { MessengerService } from '@shared/services/messenger.service';
import { NetworkUtilsService } from '@shared/services/network-utils.service';
import { TimeZoneService } from '@shared/services/timezones.service';
import { AddTeamMemberAutocompleteComponent } from './components/autocompletes/add-team-member-autocomplete/add-team-member-autocomplete';
import { DidContactAutocompleteComponent } from './components/autocompletes/did-contact-autocomplete/did-contact-autocomplete.component';
import { DidLineAutocompleteComponent } from './components/autocompletes/did-line-autocomplete/did-line-autocomplete.component';
import { DidNumberAutocompleteComponent } from './components/autocompletes/did-number-autocomplete/did-number-autocomplete.component';
import { DidPhoneAutocompleteComponent } from './components/autocompletes/did-phone-autocomplete/did-phone-autocomplete.component';
import { DivisionAutocompleteComponent } from './components/autocompletes/division-autocomplete/division-autocomplete.component';
import { GroupAutocompleteComponent } from './components/autocompletes/group-autocomplete/group-autocomplete.component';
import { IvrAutocompleteComponent } from './components/autocompletes/ivr-autocomplete/ivr-autocomplete.component';
import { UserAutocompleteComponent } from './components/autocompletes/user-autocomplete/user-autocomplete.component';
import { ConfirmationDialogComponent } from './components/confirmation-dialog/confirmation-dialog.component';
import { CustomizeColumnsPanelComponent } from './components/customize-columns-panel/customize-columns-panel.component';
import { InfoTooltipComponent } from './components/info-tooltip/info-tooltip.component';
import { NavTabsComponent } from './components/nav-tabs/nav-tabs.component';
import { NoMatchMessageComponent } from './components/no-match-message/no-match-message.component';
import { PhoneNumberInputComponent } from './components/phone-number-input/phone-number-input.component';
import { SearchPillsComponent } from './components/search-pills/search-pills.component';
import { GoogleAnalyticsDirective } from './directives/google-analytics.directive';
import { InternationalPhoneNumberDirective } from './directives/international-phone-number.directive';
import { DivisionService } from './models/divisions/division.service';
import { GroupService } from './models/groups/group.service';
import { TeamService } from './models/teams/team.service';
import { UserService } from './models/user/user.service';
import { PhoneNumberPipe } from './pipes/phone-number.pipe';
import { ApiService } from './services/api.service';
import { DiscoveryService } from './services/discovery.service';
import { SessionService } from './services/session.service';
import { StorageService } from './services/storage.service';

/** Shared module bootstrapping */
@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    RouterModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatTabsModule,
    MatTooltipModule,
    MatAutocompleteModule,
    NgSelectModule,
    FormsModule
  ],
  declarations: [
    BreadcrumbsComponent,
    StatusCircleComponent,
    SearchFieldComponent,
    PhoneNumberPipe,
    InternationalPhoneNumberDirective,
    ConfirmationDialogComponent,
    GoogleAnalyticsDirective,
    InfoTooltipComponent,
    SearchFieldComponent,
    SearchPillsComponent,
    PhoneNumberPipe,
    SearchPillsComponent,
    CustomizeColumnsPanelComponent,
    UserAutocompleteComponent,
    GroupAutocompleteComponent,
    AddTeamMemberAutocompleteComponent,
    DidPhoneAutocompleteComponent,
    IvrAutocompleteComponent,
    DidLineAutocompleteComponent,
    DidContactAutocompleteComponent,
    DidNumberAutocompleteComponent,
    PhoneNumberInputComponent,
    DivisionAutocompleteComponent,
    NavTabsComponent,
    NoMatchMessageComponent,
  ],
  exports: [
    CommonModule,
    BreadcrumbsComponent,
    SearchFieldComponent,
    StatusCircleComponent,
    PhoneNumberPipe,
    InfoTooltipComponent,
    GoogleAnalyticsDirective,
    SearchFieldComponent,
    SearchPillsComponent,
    PhoneNumberPipe,
    InternationalPhoneNumberDirective,
    SearchPillsComponent,
    CustomizeColumnsPanelComponent,
    UserAutocompleteComponent,
    GroupAutocompleteComponent,
    DidPhoneAutocompleteComponent,
    IvrAutocompleteComponent,
    DidLineAutocompleteComponent,
    DidContactAutocompleteComponent,
    DidNumberAutocompleteComponent,
    PhoneNumberInputComponent,
    DivisionAutocompleteComponent,
    NavTabsComponent,
    NoMatchMessageComponent,
    AddTeamMemberAutocompleteComponent
  ],
  providers: [
    DiscoveryService,
    SessionService,
    ApiService,
    StorageService,
    GeoIpService,
    CommunicatorService,
    NotificationService,
    MessengerService,
    TeamService,
    TranslateService,
    TimeZoneService,
    GroupService,
    NetworkUtilsService,
    UserService,
    DivisionService,
    GeoIpService
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class SharedModule {}
